<template>
    <div class="d-print-none d-lg-none">
        <transition name="slideUpDown">
            <nav id="navbar" class="navbar fixed-top" v-show="isNavbarVisible">
                <button type="button"
                        class="btn btn-link btn-link--dark d-print-none"
                        @click="openSidebar">
                    <i class="material-icons">menu</i>
                </button>
            </nav>
        </transition>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      navbarHeight: 0,
      latestOffsetY: 0,
      currentScrollTop: 0,
      ticking: false,
      container: null,
    };
  },
  mounted() {
    this.updateNavbarHeight();
    this.container = document.getElementById('dashboard');
    this.container.addEventListener('scroll', this.onScroll, false);
  },
  beforeDestroy() {
    this.container.removeEventListener('scroll', this.onScroll, false);
  },
  computed: {
    ...mapState({
      isNavbarVisible: (store) => store.navbar.isNavbarVisible,
    }),
  },
  methods: {
    openSidebar() {
      this.$store.commit('sidebar/isSidebarOpen', true);
    },
    updateNavbarHeight() {
      this.navbarHeight = document.getElementById('navbar').offsetHeight;
    },
    onScroll() {
      this.requestTick();
    },
    requestTick() {
      if (!this.ticking) {
        requestAnimationFrame(this.updateNavbarVisibility);
        this.ticking = true;
      }
    },
    updateNavbarVisibility() {
      const containerScrollTop = this.container.scrollTop;
      this.currentScrollTop = containerScrollTop;
      if (this.latestOffsetY
        < this.currentScrollTop && containerScrollTop > this.navbarHeight * 2) {
        this.$store.commit('navbar/isNavbarVisible', false);
      } else if (this.latestOffsetY
        > this.currentScrollTop && containerScrollTop > this.navbarHeight) {
        this.$store.commit('navbar/isNavbarVisible', true);
      }

      this.latestOffsetY = this.currentScrollTop;
      // prevent running requestTick until next scroll occurs
      this.ticking = false;
    },
  },
};
</script>
